export default function MetaLogo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.72819 9.55766C1.72819 10.1293 1.86231 10.5682 2.03756 10.8337C2.26737 11.1815 2.61006 11.3288 2.9595 11.3288C3.41019 11.3288 3.8225 11.2241 4.617 10.1959C5.25356 9.37181 6.00363 8.21497 6.50825 7.48977L7.36294 6.26111C7.95662 5.40784 8.64375 4.4593 9.43169 3.81632C10.0747 3.29152 10.7686 3 11.4669 3C12.6392 3 13.7559 3.63567 14.6106 4.82789C15.5459 6.13357 16 7.77819 16 9.47538C16 10.4843 15.7875 11.2257 15.4258 11.8114C15.0764 12.3778 14.3953 12.9437 13.2497 12.9437V11.3288C14.2306 11.3288 14.4754 10.4854 14.4754 9.52018C14.4754 8.14474 14.1327 6.61825 13.3777 5.5276C12.8418 4.75392 12.1474 4.28123 11.3835 4.28123C10.5573 4.28123 9.89231 4.86427 9.14506 5.90404C8.74781 6.45637 8.33994 7.12953 7.88206 7.88906L7.37794 8.72468C6.36525 10.4047 6.10875 10.7873 5.60244 11.4188C4.71494 12.5247 3.95719 12.9437 2.9595 12.9437C1.77606 12.9437 1.02763 12.4642 0.564188 11.7416C0.185813 11.1528 0 10.3802 0 9.49988L1.72819 9.55766Z"
        fill="#0081FB"
        className="path-fill"
      />
      <path
        d="M1.36261 4.94187C2.15498 3.79918 3.29836 3 4.6098 3C5.36936 3 6.12436 3.21035 6.9128 3.81269C7.77517 4.47123 8.69436 5.55567 9.84111 7.34298L10.2524 7.98433C11.2449 9.53164 11.8097 10.3276 12.1402 10.703C12.5653 11.1851 12.863 11.3288 13.2497 11.3288C14.2306 11.3288 14.4754 10.4854 14.4754 9.52018L16 9.47538C16 10.4843 15.7875 11.2257 15.4258 11.8114C15.0764 12.3778 14.3953 12.9437 13.2497 12.9437C12.5375 12.9437 11.9065 12.799 11.2088 12.1831C10.6724 11.7104 10.0454 10.8706 9.56292 10.1157L8.12792 7.87292C7.40798 6.74737 6.74748 5.90819 6.3653 5.52807C5.95417 5.11942 5.42555 4.62585 4.58205 4.62585C3.89936 4.62585 3.31955 5.07415 2.83436 5.75977L1.36261 4.94187Z"
        fill="url(#paint0_linear_590_16562)"
        className="path-fill"
      />
      <path
        d="M4.582 4.62585C3.89931 4.62585 3.3195 5.07415 2.83431 5.75977C2.14831 6.72866 1.72819 8.17175 1.72819 9.55766C1.72819 10.1293 1.86231 10.5682 2.03756 10.8337L0.564188 11.7416C0.185813 11.1528 0 10.3802 0 9.49988C0 7.89895 0.469625 6.23041 1.36263 4.94187C2.155 3.79918 3.29838 3 4.60981 3L4.582 4.62585Z"
        fill="url(#paint1_linear_590_16562)"
        className="path-fill"
      />
      <defs>
        <linearGradient
          id="paint0_linear_590_16562"
          x1="204.5"
          y1="559.193"
          x2="1304.47"
          y2="618.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop offset="0.4" stopColor="#0064E1" />
          <stop offset="0.83" stopColor="#0073EE" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_590_16562"
          x1="250.382"
          y1="726.65"
          x2="250.382"
          y2="346.608"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="1" stopColor="#0064E0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
